import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { sendPasswordResetEmail } from "../../utils/ForgotPwd";
import CustomButton from "../../components/commons/CustomBtn";
import "./login.css";
import toast from "react-hot-toast";
import ContainerXL from "../../components/Container/ContainerXL";
import { login } from "../../redux/actions/userAuthActions";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetPwd, setResetPwd] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const connect = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Veuillez entrer une adresse e-mail valide.");
      return;
    }
    dispatch(login({ email, password }, navigate));
  };
  return (
    <ContainerXL className={"vh100 "}>
      <div className="d-flex justify-content-between align-items-center bg-white h100 position-relative">
        {resetPwd && (
          <div className="backBtn" onClick={() => {
            setResetPwd(false);
          }}>
            <img src="./icons/back.svg" alt="back" />
          </div>
        )}
        <div className="w30 loginMobile d-flex flex-column align-items-center justify-content-center ">
          <div className="d-flex flex-column align-items-center justify-content-center bg-white mx-auto loginContainer">
            <div className="loginLogo">
              <img
                src="./icons/logo_novanea.svg"
                alt="main_logo"
                height={74}
                width={334}
              />
            </div>
            <div className="d-flex flex-column gap10 w100 mb-43">
              <input
                className="radius29 border-0 bg-white-grey py-20 px-20 "
                type="email"
                placeholder="Adresse e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {!resetPwd && (
                <input
                  className="radius29 border-0 bg-white-grey py-20 px-20 "
                  type="password"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              )}
            </div>
            <div className="d-flex flex-column gap20 w100">
              <CustomButton
                disabled={!email || (!resetPwd && !password)}
                label={resetPwd ? "Envoyer" : "Connexion"}
                onClick={
                  resetPwd
                    ? () => sendPasswordResetEmail(email)
                    : () => connect()
                }
                buttonClass={`bg-pink text-uppercase border-0 radius29 px-107 py-20`}
                labelClass="login-label fs14 fw-bold text-white letterSpacing-20"
              />

              {!resetPwd && (
                <CustomButton
                  label="Mot de passe oublié ?"
                  onClick={() => {
                    setResetPwd(true);
                  }}
                  buttonClass="forgot-button bg-none border-0 "
                  labelClass="forgot-label text-uppercase fs11 semibold pink mx-auto"
                />
              )}
            </div>
          </div>
          <div className="text-center mb-3">
            <div className="mb-3">
              <img
                src="./icons/logo_novanea.svg"
                alt="main_logo"
                height={24}
                width={108}
              />
            </div>
            <p className="fs9 medium softerGrey ">Logiciel édité par Novanéa</p>
            <p className="fs9 medium softerGrey ">
              Tous droits réservé ©Novanéa FRANCE 2025
            </p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://tendances.group/"
              className="fs9 medium softerGrey custom-button underlineHover"
            >
              Tendances Group
            </a>
          </div>
        </div>
        <div className="w70 loginPhotoContainer">
          <img
            src="./assets/login_photo.webp"
            alt="login_photo"
            className="loginPhoto"
          />
        </div>
      </div>
    </ContainerXL>
  );
};

export default Login;
